import { ChangeDetectorRef, Component, HostListener, Inject, PLATFORM_ID, Renderer2 } from '@angular/core';
import { HeaderComponent } from "../../header/header.component";
import { FooterComponent } from '../../footer/footer.component';
import { CommonModule } from '@angular/common';
import { WebService } from '../../services/web.service';
import { HttpClient, HttpClientModule, HttpHeaders } from '@angular/common/http';
import { MetaTagService } from '../../meta-tag.service';
import { environment, GINConstants } from '../../../environments/environments';
import { IconsFreeToolsComponent } from '../../icons-free-tools/icons-free-tools.component';
import { FormsModule } from '@angular/forms';
import { PremiumComponent } from "../../premium/premium.component";
import { PremiumModalStartupComponent } from '../../premium-modal/premium-modal.component';
import { FeedbackComponent } from "../../feedback/feedback.component";
import { RecaptchaModule, RECAPTCHA_SETTINGS } from 'ng-recaptcha';
@Component({
  selector: 'app-ai-paragraph-generator',
  standalone: true,
  imports: [HeaderComponent, CommonModule, HttpClientModule, FooterComponent, IconsFreeToolsComponent, FormsModule, PremiumComponent,
    PremiumModalStartupComponent, FeedbackComponent, RecaptchaModule],
  templateUrl: './ai-paragraph-generator.component.html',
  styleUrl: './ai-paragraph-generator.component.css'
})
export class AIParagraphGeneratorComponent {
  shouldShowButton: boolean = false;
  ngOnInit(): void {
    this.metaService.updateTags("Free AI Paragraph Generator", "AI paragraph generator generate informational, persuasive and conversational paragraphs in seconds. Write unique paragraphs with our paragraph writer for free.", "https://www.grammarin.com/ai-paragraph-generator", "https://www.grammarin.com/assets/images/OG-Images/AI Paragraph Generator.png", 'AI Paragraph Generator');
    this.loadTurnstileScript().then(() => this.renderTurnstile())
  }
  constructor(private cdr: ChangeDetectorRef, private _webservice: WebService, @Inject(PLATFORM_ID) private platformID: Object, private httpClient: HttpClient, private metaService: MetaTagService) { }

  @HostListener('window:scroll', [])
  onWindowScroll() {
    if (window.pageYOffset > 200) {
      this.shouldShowButton = true;
    } else {
      this.shouldShowButton = false;
    }
  }
  scrollToTop() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }
  public form_detail: any;
  public form_tone: any;
  public form_topic: any;

  public checkEmptyFields(form) {
    let emptyFields = [];


    if (form.form_detail.trim() === '') {
      emptyFields.push('form_detail');
    }
    if (form.form_topic.trim() === '') {
      emptyFields.push('form_topic');
    }
    if (form.form_tone.trim() === '') {
      emptyFields.push('form_tone');
    }
    return emptyFields;
  }
  public color: string = 'black';
  public esubText: string = '';
  public esubText2: string = '';
  eFsubText2: any;
  public loaderAlert: boolean = false;
  output: any;
  original: any;
  corrected: any;
  public eFsubIF: boolean = false;
  output_display = false;
  public eFormSubmission(event: any) {

    if (this.captchaToken) {
  

    this.got_recpatcha = false;
  } else {
    this.got_recpatcha = true;
  
    $('#dangerAlert').html('Captcha is not loaded. Please reload the page.');
    $('#dangerAlert').show();
    setTimeout(function () {
      $('#dangerAlert').hide();
    }, 3000);
  
    return
  }

    this.output_display = false;
    event.preventDefault();
    this.eFsubIF = false
    this.form_detail = $('#form_detail').val();
    this.form_tone = $('#form_tone').val();
    this.form_topic = $('#form_topic').val();


    //  words limts 
    this.textValue = this.form_detail;
    this.textValueTopic = this.form_topic;

    this.checkWordLimitForParagraph(event);
    this.checkWordLimitForTopic(event);

    let paragraphWords = this.textValue.trim().split(/\s+/).length;
    let topicWords = this.textValueTopic.trim().split(/\s+/).length;

    if (paragraphWords > this.wordLimit || topicWords > this.wordTopicLimit) {
      this.color = '#721c24';
      this.eFsubText2 = `Word limit exceeded! Paragraph: ${this.wordLimit} words, Topic: ${this.wordTopicLimit} words.`;

      // Highlight fields that exceed limits
      if (paragraphWords > this.wordLimit) $('#form_detail').css("border-color", "red");
      if (topicWords > this.wordTopicLimit) $('#form_topic').css("border-color", "red");

      this.eFsubIF = true;
      $("#eFsubText2").show();
      setTimeout(() => {
        $("#eFsubText2").hide();
        // $('#form_detail, #form_topic').css("border-color", "#08BA9C");
        this.eFsubIF = false;
      }, 3000);

      return;
    }
    //  words limts 






    let form = {
      form_detail: this.form_detail,
      form_topic: this.form_topic,
      form_tone: this.form_tone
    };
    let emptyFields = this.checkEmptyFields(form);
    if (emptyFields.length > 0) {
      this.color = '#721c24';
      this.eFsubText2 = 'Please provide the required fields';
      emptyFields.forEach(function (field) {
        $('#' + field).css("border-color", "red");
      });
      this.eFsubIF = true
      $("#eFsubText2").show();
      setTimeout(function () {
        $("#eFsubText2").hide();
        emptyFields.forEach(function (field) {
          $('#' + field).css("border-color", "#08BA9C");
        });
        this.eFsubIF = false
      }, 3000);
    }
    else {
      this.loaderAlert = true;
      const headers = new HttpHeaders({
        'Authorization': environment.AuthorizationGIN,
      });
      this.httpClient.post(environment.API_URL + '/api/aiParagraphN', { 'detail': this.form_detail, 'topic': this.form_topic, 'tone': this.form_tone }, { headers }).subscribe(
        (response) => {
          this.output_display = true;
          this.output = response['output']
          this.loaderAlert = false;
          if (this.wordCount >= this.wordLimit || this.wordTopicCount >= this.wordTopicLimit){
            $('#form_detail').css("border-color", "red").css("background-color", "white");;;
            $('#form_topic').css("border-color", "red").css("background-color", "white");;;
          }
          else {
            $('#form_detail').css("border-color", "#08BA9C").css("background-color", "white");;;
            $('#form_topic').css("border-color", "#08BA9C").css("background-color", "white");;;
            $('#form_tone').css("border-color", "#08BA9C").css("background-color", "white");;;
          }
         
        },
        (error) => {
          console.error(error);
          this.output_display = true;
          this.loaderAlert = false;
          this.output = "Something went wrong. Please try again later.";
          // $('#form_detail').val('').css("border-color", "#08BA9C");
          // $('#form_topic').val('').css("border-color", "#08BA9C");
          // $('#form_tone').val('').css("border-color", "#08BA9C");
        }
      );

    }
  }

  public copiedtext: boolean = false;
  public copried_txt: string = '';
 

  copyToClipboard() {
    if (this.output) {
   
      const tempDiv = document.createElement('div');
      tempDiv.innerHTML = this.output;
      const plainText = tempDiv.innerText || tempDiv.textContent; 
      const textArea = document.createElement('textarea');
      textArea.value = plainText.trim(); 
      document.body.appendChild(textArea);
      textArea.select();
      document.execCommand('copy');
      document.body.removeChild(textArea);
      this.copiedtext = true;
      setTimeout(() => {
        this.copiedtext = false;
      }, 2000);
    }
  }
  reFreshWindow() {
    $('#form_detail').val('').css("background-color", "rgba(247, 247, 250, 1)");
    $('#form_topic').val('').css("background-color", "rgba(247, 247, 250, 1)");
    $('#form_tone').val('').css("background-color", "rgba(247, 247, 250, 1)");
    this.output_display = false;
    this.wordCount = 0;
    this.wordTopicCount = 0;
  }
  textValue: string = '';
  textValueTopic: string = '';
  wordLimit: number = 100;
  wordTopicLimit: number = 50;
  wordCount: number = 0;
  wordTopicCount: number = 0;
  borderColorParagraph: string = '#08BA9C';
  borderColorTopic: string = '#08BA9C';

  checkWordLimitForParagraph(event: KeyboardEvent) {
    let words = this.textValue.trim().split(/\s+/);
    this.wordCount = this.textValue.trim().split(/\s+/).filter(word => word.length > 0).length;
    this.wordCount = words[0] === "" ? 0 : words.length;

  
    this.borderColorParagraph = this.wordCount >= this.wordLimit ? 'red' : '#08BA9C';

    setTimeout(() => {
      this.wordCount = this.textValue ? this.textValue.trim().split(/\s+/).filter(word => word).length : 0;
      this.borderColorParagraph = this.wordCount >= this.wordLimit ? 'red' : '#08BA9C';
    });
  }

  checkWordLimitForTopic(event: KeyboardEvent) {
    let words = this.textValueTopic.trim().split(/\s+/);
    this.wordTopicCount = this.textValueTopic.trim().split(/\s+/).filter(word => word.length > 0).length;
    this.wordTopicCount = words[0] === "" ? 0 : words.length;

  
    this.borderColorTopic = this.wordTopicCount >= this.wordTopicLimit ? 'red' : '#08BA9C';
    setTimeout(() => {
      this.wordTopicCount = this.textValueTopic?.trim().split(/\s+/).filter(word => word).length || 0;
      this.borderColorTopic = this.wordTopicCount >= this.wordTopicLimit ? 'red' : '#08BA9C';
    });
  }

  // array 
  Tools = [
    {
      icon: 'pasteIcon',
      heading: 'Enter Your Topic',
      description: 'Start by providing a keyword, phrase or topic you want the paragraph to be about.',
    },
    {
      icon: 'hitheIcon',
      heading: 'Select Tone of Writing',
      description: 'You are allowed to select the tone, style or length of the paragraph.',
    },
    {
      icon: 'highlightedicon',
      heading: 'Generate Paragraph',
      description: 'Click the “Generate AI Paragraph” and the AI will create a well-structured paragraph instantly.',
    },
    {
      icon: 'doublePageIcon',
      heading: 'Copy & Use',
      description: 'Copy the text and use it for your blog, article or any other purpose you want.',
    },
  ];
  writingStyler = [
    {
      title: 'Random Paragraphs',
      description: `
Need a quick paragraph for inspiration, practice, or creative exercises? The random paragraph generator can instantly produce well-structured, meaningful text on various topics, helping users generate fresh ideas or fill content gaps easily.`,
    },
    {
      title: 'Introduction Paragraphs',
      description: `A compelling introduction sets the tone for any piece of writing. The introduction paragraph generator creates engaging introduction paragraphs that capture attention and provide a clear preview of the content that follows.`,
    },
    {
      title: 'Conclusion Paragraphs',
      description: `A strong conclusion sums up the whole discussion and leaves a lasting impression on readers. This conclusion paragraph generator crafts concise, impactful conclusion paragraphs that <a href="https://www.grammarin.com/ai-summarizer"  rel="noopener noreferrer" style="text-decoration: underline !important; color: #007bff !important;" class="href-style">summarize information </a>. It curates a smooth wrap-up for essays, articles, reports, etc.`,
    },
    {
      title: 'Roast Paragraphs',
      description: `If you want to add humor or playful sarcasm to your writing, our roast paragraph generator  can generate witty and sharp roast paragraphs, perfect for friendly banter, light-hearted critiques, or entertaining content with a humorous edge.`,
    },

  ];

  TWCF = [
    {
      icon: 'writerIcon',
      heading: 'Content Writers',
      description: 'Content writers need to produce high-quality text quickly for blogs, articles, or marketing materials. The AI paragraph generator helps them generate well-structured and engaging content, saving time and enhancing productivity.',
    },
    {
      icon: 'studentIcon',
      heading: 'Students',
      description: 'Academic writing requires originality, clarity, and coherence, which can be challenging for students when facing tight deadlines. Our free AI paragraph writer assists them in creating well-organized content for their written project.',
    },
    {
      icon: 'teacherIcon',
      heading: 'Teachers',
      description: 'Teachers may find it essential to create personalized educational materials and lesson plans for their students. They can utilize the auto paragraph generator to streamline the process by generating structured paragraphs automatically.',
    },
    {
      icon: 'websiteIcon',
      heading: 'Website Owners',
      description: 'Running a website demands regular content updates for blogs, product descriptions, and informational pages. The paragraph generator provides website owners with unique, SEO-friendly content that maintains consistency and engagement with their audience.',
    },

    {
      icon: 'freelancersicon',
      heading: 'Freelancers',
      description: 'Freelancers are mostly juggling multiple writing tasks on a daily basis. With this AI-powered tool, they can generate polished paragraphs that meet different writing styles and client requirements.',
    },
  ];
  CGEDU = [
    {
      icon: 'writeParagraphsWithAiIcon',
      title: 'Write Paragraphs with AI',
      description: `The online paragraph writer uses AI capabilities to write well-structured and coherent paragraphs. The cutting-edge technology used in the tool curates high-quality text with logical flow and readability.`,

    },
    {
      icon: 'unlimitedFreeUsageIcon',
      title: 'Unlimited Free Usage',
      description: `Unlike many other tools, our free AI paragraph generator offers unlimited access without hidden charges. Users can generate as many paragraphs as needed without worrying about restrictions or any premium plans.`,

    },
    {
      icon: 'zeroGrammarMistakesIcon',
      title: 'Zero Grammar Mistakes',
      description: `  Our paragraph maker ensures flawless writing by eliminating grammatical errors and awkward phrasing. Every generated paragraph is checked for proper syntax, punctuation, and sentence structure, making it ready to use instantly. For further rectification, you can use the         <a href="https://www.grammarin.com/grammar-checker" target="_blank" rel="noopener noreferrer" style="text-decoration: underline !important; color: #007bff !important;" class="href-style">grammar checker</a> tool.`,

    },
    {
      icon: 'quickResultsIcon',
      title: 'Quick Results',
      description: `With advanced AI algorithms, the paragraph writer produces results within seconds to save time and effort. So, users can get high-quality content in the form of paragraphs instantly instead of spending time brainstorming or rewriting.`,

    },
    {
      icon: 'multipleWritingTonesIcon',
      title: 'Multiple Writing Tones',
      description: `The professional paragraph generator adapts to different <a href="https://editor.grammarin.com/handbook/style"  rel="noopener noreferrer" style="text-decoration: underline !important; color: #007bff !important;" class="href-style">writing styles </a> without any extra settings. It allows users to generate paragraphs in a tone that suits their needs. You can generate formal, conversational, or persuasive paragraphs easily.`,

    },
    {

      icon: 'freePlagiarismParagrapghIcon',
      title: 'Free of Plagiarism',
      description: `The paragraphs generated by the AI paragraph writer are completely original and plagiarism-free. It generated paragraphs from scratch to ensure uniqueness in every output. Therefore, it could be used for academic, professional, and creative writing without concerns about duplicate content. To analyze the output deeply, you can compare it using our advanced  <a href="https://www.grammarin.com/plagiarism-checker" target="_blank" rel="noopener noreferrer" style="text-decoration: underline !important; color: #007bff !important;" class="href-style"> plagiarism checker.</a>`,

    },
  ];

  // Method to mark the text as safe strong text for display
  getSafeHtml(description: string): string {
    return description;
  }
  // Method to mark the text as safe strong text for display

  recaptcha_message: string = "";


  loadTurnstileScript(): Promise<void> {
  return new Promise((resolve, reject) => {
    if (typeof window['turnstile'] !== 'undefined') {
      resolve();
      return;
    }

    const script = document.createElement('script');
    script.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js';
    script.async = true;
    script.defer = true;
    script.onload = () => resolve();
    script.onerror = () => reject('Failed to load Turnstile script');
    document.body.appendChild(script);
  });
}

renderTurnstile(): void {
  if (typeof window['turnstile'] !== 'undefined') {
    window['turnstile'].render('#recaptcha-container', {
      sitekey: environment.CaptchaKey, 
      size: 'normal', 
      callback: (token: string) => this.onTurnstileSuccess(token),
      'error-callback': () => this.onTurnstileError(),
    });
   
  } else {
    // console.error('Turnstile script not loaded.');
  }
}

  got_recpatcha : boolean = false;
  captchaToken: string | null = null;
  captchaResponse: string;

onTurnstileSuccess(token: string): void {
  // console.log('Turnstile token received:', token);
  this.captchaToken = token; 
}

// Error callback when CAPTCHA fails
onTurnstileError(): void {
  // console.error('Turnstile error occurred.');
  this.captchaToken = null; 
}
  onCaptchaResolved(captchaResponse: string) {
    this.captchaResponse = captchaResponse;
  }
  }




